import React from 'react';
import { Grid } from '@mui/material';
import PanelHeader from '../../components/panelheader/panelHeader';
import { Textarea } from '../../components/input';
import * as uhaCss from '../activity.uha.module.scss';
import * as studentCss from '../activity.student.module.scss';
import classNames from 'classnames';

type FritekstSectionProps = {
  fritekst: string;
  title: string;
  subtitle: string;
};

// Exported to student view (activity.student.tsx) and ps view (detaljer.psa.tsx)
const FritekstSectionReadOnly: React.FC<
  React.PropsWithChildren<FritekstSectionProps>
> = ({ fritekst, title, subtitle }) => (
  <Grid item xs={12}>
    <PanelHeader title={title} subtitle={subtitle} collapsible>
      <Textarea
        htmlId={'activity-fritekst'}
        className={classNames(uhaCss.fritekst, studentCss.fritekst)}
        value={fritekst}
        readOnly
      />
    </PanelHeader>
  </Grid>
);

export default FritekstSectionReadOnly;
